import PositionBackendManagement from './routes'
import 'windi.css'

export default {
  // name version 必须为字面常量
  name: 'position-backend-management',
  title: '定位后台',
  version: '0.1.29',
  description: '定位后台',
  routes: PositionBackendManagement, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: [
      'BuildingApi',
      'ModelSceneApi',
      'ModelSceneApi',
      'CompositeStateApi',
      'ClipApi',
      'FloorApi',
      'BuildingApi',
    ],
  },
  config: {
    modelSetting: {
      cloudRenderLoadMode: 'video',
      cloundServerPath: '192.168.20.79:8082',
      cloundProtocol: 'ws',
      globalMapPath: 'data://map-prpk-local.gis.xml',
      modelAnimationSuffix: 'prAni',
      loadModelType: 'documentId',
      standardAlarmSetting: true,
      folderName: 'SAAS',
      modelFileList: [
        {
          md5: '4dc8c1c08ccfdb184493fd5dc01bcbbe',
          fileId: '3a0ce65f-5eb5-dc8a-1084-171d8c0de573',
          fileName: '汽轮机(1).pr',
          id: '3a0ce65f-5eb5-dc8a-1084-171d8c0de573',
          name: 'ModelFileId',
          Latitude: 30.67,
          Longitude: 104.06,
          Elevation: 0,
          IsAutoFollowFloor: true,
        },
      ],
    },
  },
  /**
   * init: async (store, router, config) {}
   * 异步初始化函数原型
   */
}
